/* eslint-disable jira/naming/disallow-filenames */
import React from 'react';
import type ProjectSettingsProformaJiraFormBuilderType from '@jira/spa-apps__project-settings-proforma-jira-form-builder/src/ProformaJiraFormBuilderPage.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsProformaJiraFormBuilder: LazyComponent<
	() => React.JSX.Element | null
> = lazyForPaint<typeof ProjectSettingsProformaJiraFormBuilderType>(
	() =>
		import(
			/* webpackChunkName: "async-project-settings-proforma-jira-form-builder", jiraSpaEntry: "async-project-settings-proforma-jira-form-builder" */ '@jira/spa-apps__project-settings-proforma-jira-form-builder/src/ProformaJiraFormBuilderPage.tsx'
		),
);

const AsyncProjectSettingsProformaJiraFormBuilder = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsProformaJiraFormBuilder}
		pageId="project-settings-proforma-jira-form-builder"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsProformaJiraFormBuilder;
